import type { Components, Theme } from "@mui/material";

import { defaultFontFamily } from "../fontFamily.ts";

export const inputBaseTheme: Components<Theme>["MuiInputBase"] = {
  defaultProps: {
    size: "small",
  },
  styleOverrides: {
    root: ({ theme }) => ({
      fontFamily: defaultFontFamily,
      color: theme.palette.text.main,
      minHeight: "40px",
    }),
  },
};
